import { useEffect } from "react";
import { useVisibleContainer } from "../hooks/useVisibleContainer";
import { loadCredits, loadGiftCatalog } from "../../creditsApi";

// Route-effect component for "/gifts/send". Renders nothing -
// SendGiftScreen.tsx (mounted unconditionally in AppRoot) owns the actual
// rendering into #sendGiftView, which this only shows/hides, same pattern
// as every other route screen (see GiftsRouteScreen.tsx). Reloads credits/
// catalog on mount so a direct nav/refresh straight to /gifts/send shows
// current data rather than whatever was last loaded elsewhere.
export function SendGiftRouteScreen() {
  useVisibleContainer("sendGiftView");

  useEffect(() => {
    loadCredits();
    loadGiftCatalog();
  }, []);

  return null;
}
